import { Component, EventEmitter, Input, OnChanges, Output, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { from, of } from 'rxjs';
import { catchError, mergeMap, toArray } from 'rxjs/operators';
import { BarManagementService, Organization } from 'src/app/api/api-bar-management.service.generated';
import { LocationFilterByOrganizationId } from 'src/app/api/api-campaigns.service.generated';
import { ConfirmDialogModel, DataTableComponent, TableColumn } from 'wecheer-common';

@Component({
  selector: 'app-filter-by-organization-id',
  templateUrl: './filter-by-organization-id.component.html',
  styleUrls: ['./filter-by-organization-id.component.scss'],
  imports: [
    MatIconModule,
    DataTableComponent
  ]
})
export class FilterByOrganizationIdComponent implements OnChanges {
  private dialog = inject(MatDialog);
  private bmApi = inject(BarManagementService);


  @Input() model: LocationFilterByOrganizationId;

  @Output() deleteOrganisationId = new EventEmitter<string>();

  organisations: Organization[];
  columns: TableColumn[] = [
    { name: 'name', header: 'Organization' },
    { name: 'description', header: 'Description' },
    {
      name: 'actions', header: 'Actions',
      actionButtons: [
        { icon: 'delete', color: 'primary', tooltip: 'Delete', handler: (org: Organization) => this.onDelete(org) }
      ]
    }
  ];

  ngOnChanges(): void {
    if (!this.model) return;

    this.refresh();
  }

  async refresh() {
    from(this.model.organizationIds).pipe(
      mergeMap(id => this.bmApi.getAdminOrganizationById(parseInt(id)).pipe(catchError(() => of(null))), 4),
      toArray(),
    ).subscribe(res => {
      this.organisations = res;
    });
  }


  async onDelete(org: Organization) {
    const dialogModel = ConfirmDialogModel.danger(
      'Are you sure you want to delete this organisation?',
      'Delete organisation?'
    );
    const confirmResult = await dialogModel.show(this.dialog);
    if (!confirmResult) return;

    const id = org.id.toString();
    this.deleteOrganisationId.emit(id);
  }

}
